import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { SlidersHorizontalIcon } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AnalysisDataExtractionJobs } from './AnalysisDataExtractionJobs';
import { StoreSkuSettingValuesForm } from './StoreSkuSettingValuesForm';
import type { SimpleAccount } from '@/lib/types';

interface StoreSkuSettingValuesExtractionProps {
  account: SimpleAccount;
}

/**
 * 店舗×SKU 設定値リストタブのコンテンツ（FKV3-12855）
 * 抽出条件・実行ログをサブタブで切り替える（他メニューと同じ構成）
 */
export function StoreSkuSettingValuesExtraction({ account }: StoreSkuSettingValuesExtractionProps) {
  const [activeTab, setActiveTab] = useState('form');

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <SlidersHorizontalIcon size={24} style={{ marginRight: 8 }} />
        店舗×SKU 設定値リスト
      </Typography>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="form">抽出条件</TabsTrigger>
          <TabsTrigger value="logs">実行ログ</TabsTrigger>
        </TabsList>

        <TabsContent value="form" className="mt-6">
          <StoreSkuSettingValuesForm account={account} onSubmitted={() => setActiveTab('logs')} />
        </TabsContent>

        <TabsContent value="logs" className="mt-6">
          <AnalysisDataExtractionJobs account={account} menuType="store_sku_setting_values" />
        </TabsContent>
      </Tabs>
    </Box>
  );
}
